import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Edit, Trash2 } from 'lucide-react';
import type { ReleaseListItemDto } from '../types';

interface ReleaseNotesAdminTableProps {
  data: ReleaseListItemDto[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

export function ReleaseNotesAdminTable({
  data,
  onEdit,
  onDelete,
}: ReleaseNotesAdminTableProps) {
  if (data.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        No releases found. Create your first release.
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Versions</TableHead>
          <TableHead>Title</TableHead>
          <TableHead>Release Date</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-center">Content</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((release) => (
          <TableRow key={release.id}>
            <TableCell className="font-mono text-sm">
              <div>Web {release.webVersion}</div>
              <div className="text-muted-foreground">Mobile {release.mobileVersion}</div>
            </TableCell>
            <TableCell>{release.title}</TableCell>
            <TableCell>
              {new Date(release.releaseDate).toLocaleDateString()}
            </TableCell>
            <TableCell>
              {release.isPublished ? (
                <Badge className="bg-success/10 text-success border-success/30" variant="outline">
                  Published
                </Badge>
              ) : (
                <Badge variant="outline" className="text-muted-foreground">
                  Draft
                </Badge>
              )}
            </TableCell>
            <TableCell className="text-center text-sm">
              {release.highlightCount > 0 && (
                <div>{release.highlightCount} highlight{release.highlightCount !== 1 ? 's' : ''}</div>
              )}
              <div>{release.noteCount} item{release.noteCount !== 1 ? 's' : ''}</div>
            </TableCell>
            <TableCell className="text-right">
              <div className="flex justify-end gap-1">
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(release.id)}
                >
                  <Edit className="h-4 w-4" />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onDelete(release.id)}
                >
                  <Trash2 className="h-4 w-4 text-destructive" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
